import React from 'react'
import GraphOne from "./graphs/graphOne";
import GraphTwo from "./graphs/graphTwo";
import GraphThree from "./graphs/graphThree";
import Alert from "../elements/alert";
import {useSelector} from "react-redux";

const AnalyticsPage = () => {

    const alertBox = useSelector(state => state.app.alertBox)
    const theme = useSelector(state => state.app.theme)

    const graphsSettings = {
        plugins: {
            tooltip: {
                intersect: false,
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';

                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'UZS' }).format(context.parsed.y);
                        }
                        return label;
                    }
                }
            }
        },
    }

    return (
        <div className="content">
            {alertBox && <Alert text={alertBox.text} type={alertBox.type}/>}
            <div className={`wrapper ${theme}`}>
                <div className="charts">
                    <GraphOne settings={graphsSettings}/>
                </div>
                <div className="charts">
                    <GraphTwo settings={graphsSettings}/>
                </div>
                <div className="charts">
                    <GraphThree settings={graphsSettings}/>
                </div>
            </div>
        </div>
    )
}

export default React.memo(AnalyticsPage)